import React from 'react'
import { IFlexProps } from 'typescript-styled-flex'
import Wrapper from './Header/Wrapper'

function ModalHeader({ children, ...rest }: IModalHeaderProps & IFlexProps) {
  return <Wrapper {...rest}>{children}</Wrapper>
}

export default ModalHeader

export interface IModalHeaderProps {
  children: React.ReactNode
  style?: React.CSSProperties
}
